import OfficialsScreen from './containers/officialsScreen'

export {default as OfficialsScreenLayout} from './components/officialsScreenLayout'

export default OfficialsScreen
